import { create } from 'zustand'

export type ToastTone = 'success' | 'error' | 'info'

/** Ação opcional no aviso (ex.: "Desfazer"); o aviso fecha ao clicar. */
export interface ToastAction {
  label: string
  onClick: () => void
}

export interface Toast {
  id: string
  tone: ToastTone
  message: string
  action?: ToastAction
}

interface ToastState {
  toasts: Toast[]
  push: (tone: ToastTone, message: string, action?: ToastAction) => void
  dismiss: (id: string) => void
}

const AUTO_DISMISS_MS = 4500
/** Com ação, o aviso fica mais tempo para dar tempo de clicar. */
const AUTO_DISMISS_ACTION_MS = 8000

export const useToastStore = create<ToastState>((set, get) => ({
  toasts: [],
  push: (tone, message, action) => {
    const id = crypto.randomUUID()
    set((state) => ({ toasts: [...state.toasts, { id, tone, message, action }] }))
    setTimeout(() => get().dismiss(id), action ? AUTO_DISMISS_ACTION_MS : AUTO_DISMISS_MS)
  },
  dismiss: (id) => set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) })),
}))

/** API imperativa para uso fora de componentes (hooks de mutação, etc). */
export const toast = {
  success: (message: string, action?: ToastAction) =>
    useToastStore.getState().push('success', message, action),
  error: (message: string) => useToastStore.getState().push('error', message),
  info: (message: string) => useToastStore.getState().push('info', message),
}
